import React from 'react';
import { AddShiftSetModal } from './add-shift-set-modal.component';
import { useAddShiftSetModalService } from './add-shift-set-modal.service';
import type { AddShiftSetModalContainerProps } from './add-shift-set-modal.types';

export const AddShiftSetModalContainer = (
  props: AddShiftSetModalContainerProps,
) => {
  const serviceProps = useAddShiftSetModalService(props);
  return <AddShiftSetModal {...serviceProps} />;
};
